export default __webpack_public_path__ + "static/media/malzoni3.d23c97e8.jpg";